var moduleMap = {
	"./noop": function() {
		return Promise.all(/* __federation_expose_noop */[__webpack_require__.e(8884), __webpack_require__.e(5120)]).then(function() { return function() { return (__webpack_require__(5827)); }; });
	},
	"./react": function() {
		return __webpack_require__.e(/* __federation_expose_react */ 6593).then(function() { return function() { return (__webpack_require__(2155)); }; });
	},
	"./react-dom": function() {
		return Promise.all(/* __federation_expose_react_dom */[__webpack_require__.e(6593), __webpack_require__.e(8884)]).then(function() { return function() { return (__webpack_require__(316)); }; });
	},
	"./next/router": function() {
		return Promise.all(/* __federation_expose_next__router */[__webpack_require__.e(7018), __webpack_require__.e(5371), __webpack_require__.e(3047), __webpack_require__.e(8884), __webpack_require__.e(2285), __webpack_require__.e(5286)]).then(function() { return function() { return (__webpack_require__(3047)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope, remoteEntryInitOptions) {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};
__webpack_require__(4842)

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});